import { generatePath } from 'react-router-dom'

import Routes from '@tabeeb/routes'

import OpenInNewTabIconButton from '../OpenInNewTabIconButton'

export interface TrainingMaterialLinkButtonProps {
  id: number
  disabled?: boolean
}

const TrainingMaterialLinkButton: React.FC<TrainingMaterialLinkButtonProps> = ({ id, disabled = false }) => {
  return <OpenInNewTabIconButton disabled={disabled} url={generatePath(Routes.trainingMaterialView, { id })} />
}

export default TrainingMaterialLinkButton
